namespace GeniuzPOS.Product {
    export interface PsSetItemDtRow {
        Id?: number;
        SetItemCode?: string;
        PluCode?: string;
        PluDesc?: string;
        Qty?: number;
        Unit?: string;
        NormalUnitPrice?: number;
        SetUnitPrice?: number;
        SetPrice?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        LineItemNo?: number;
    }

    export namespace PsSetItemDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'Product.PsSetItemDt';
        export const lookupKey = 'Product.PsSetItemDt';

        export function getLookup(): Q.Lookup<PsSetItemDtRow> {
            return Q.getLookup<PsSetItemDtRow>('Product.PsSetItemDt');
        }
        export const deletePermission = '1POSBASE:การจัดชุดสินค้า:Delete';
        export const insertPermission = '1POSBASE:การจัดชุดสินค้า:Modify';
        export const readPermission = '1POSBASE:การจัดชุดสินค้า:View';
        export const updatePermission = '1POSBASE:การจัดชุดสินค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            SetItemCode = "SetItemCode",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            Qty = "Qty",
            Unit = "Unit",
            NormalUnitPrice = "NormalUnitPrice",
            SetUnitPrice = "SetUnitPrice",
            SetPrice = "SetPrice",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            LineItemNo = "LineItemNo"
        }
    }
}
